import { ref } from 'vue'

export function useEmailLogin() {
  const loading = ref(false)
  const error = ref<string | null>(null)
  const emailSent = ref(false)

  async function sendLoginCode(email: string): Promise<boolean> {
    loading.value = true
    error.value = null
    try {
      const res = await fetch(new URL('authenticates/email', import.meta.env.VITE_APP_API_ROOT), {
        method: 'POST',
        body: JSON.stringify({
          application: import.meta.env.VITE_APP_NAME,
          email: email,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!res.ok) {
        if (res.status === 401) {
          error.value = 'common.email_login_invalid_email'
        } else if (res.status === 409) {
          error.value = 'common.email_login_locked_15_min'
        } else if (res.status === 429) {
          error.value = 'common.too_many_attempts'
        } else if (res.status === 500 || res.status === 502) {
          error.value = 'common.email_login_delivery_failed'
        } else {
          error.value = 'common.email_login_unknown_error'
        }
        emailSent.value = false
        return false
      }
      emailSent.value = true
      return true
    } catch {
      error.value = 'common.email_login_delivery_failed'
      emailSent.value = false
      return false
    } finally {
      loading.value = false
    }
  }

  return {
    sendLoginCode,
    loading,
    error,
    emailSent,
  }
}
